import gql from "graphql-tag";

export const setFournisseur = gql`
  mutation setFournisseur(
    $utilisateurId: Int!
    $name: String!
    $fournisseurId: Int
    $cleanDescription: String!
    $entreprise: Int
    $montant: Float!
    $frequencyType: String!
    $referenceDate: String!
  ) {
    setFournisseur(
      utilisateurId: $utilisateurId
      name: $name
      fournisseurId: $fournisseurId
      cleanDescription: $cleanDescription
      entreprise: $entreprise
      montant: $montant
      frequencyType: $frequencyType
      referenceDate: $referenceDate
    ) {
      type
      message
      details
    }
  }
`;

export const setTransaction = gql`
  mutation setTransaction(
    $utilisateurId: Int!
    $transactionId: String!
    $montant: Float!
    $tva: Float
  ) {
    setTransaction(
      utilisateurId: $utilisateurId
      transactionId: $transactionId
      montant: $montant
      tva: $tva
    ) {
      type
      message
      details
    }
  }
`;

export const splitTransaction = gql`
  mutation splitTransaction(
    $utilisateurId: Int!
    $transactionId: String!
    $unsplit: Boolean
  ) {
    splitTransaction(
      utilisateurId: $utilisateurId
      transactionId: $transactionId
      unsplit: $unsplit
    ) {
      type
      message
      details
    }
  }
`;

export const setCategorie = gql`
  mutation setCategorie(
    $utilisateurId: Int!
    $produitId: Int
    $frequenceId: Int!
  ) {
    setCategorie(
      utilisateurId: $utilisateurId
      produitId: $produitId
      frequenceId: $frequenceId
    ) {
      type
      message
      details
    }
  }
`;
